import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import { screen } from '@styles/mixins/breakpoints';
import { fonts, getTypographyStyles } from '@styles/variables';

const getDefaultHeading = (isImageSmall, isImageExist) => css`
  margin-bottom: ${isImageSmall ? '4px' : '12px'};
  font: 24px /
      ${(isImageSmall && '36px') || (!isImageExist && '36px') || '36px'}
      gt-america-extended-bold,
    Arial, sans-serif;
`;

const getHeadingWithSubTitle = (isImageSmall, isImageExist) => css`
  font-family: 'gt-america-expanded-bold', Arial, sans-serif;
  line-height: inherit;

  ${isImageSmall && !isImageExist
    ? css`
        b {
          display: block;
          ${getTypographyStyles.heading()};
        }

        span {
          ${getTypographyStyles.body()}
        }
      `
    : css`
        margin-bottom: 32px;
        b {
          display: block;
          font-size: 40px;
          line-height: 60px;
          word-break: break-word;

          ${screen.l(css`
            font-size: 36px;
            line-height: 40px;
          `)}
        }

        span {
          ${getTypographyStyles.heading2()}
        }
      `};
`;

const informationTitleCssRules = css`
  ${({ isSubTitleExists, isImageSmall, isImageExist }) => (isSubTitleExists
    ? getHeadingWithSubTitle(isImageSmall, isImageExist)
    : getDefaultHeading(isImageSmall, isImageExist))};

  margin-bottom: ${({ isSubTitleExists }) => !isSubTitleExists && '16px'};

  word-break: break-word;

  ${({ isSubTitleExists }) => isSubTitleExists
    && screen.tablet(css`
      font-size: 20px;
      line-height: 24px;
    `)}

  ${({ isSubTitleExists }) => !isSubTitleExists
    && screen.l(css`
      b {
        font-size: 35px;
        line-height: 42px;
      }
    `)}

  ${({ isFactAndFigure }) =>
    isFactAndFigure &&
    css`
       {
        font-size: 32px !important;
        margin-bottom: 4px !important;
      }
    `}
`;

const StyledInformationTitle = styled.h3`
  ${informationTitleCssRules}
`;

const StyledInformationTitleLink = styled(Link)`
  color: black;
  text-decoration: none;

  &:active {
    color: -webkit-activelink;
  }
`;

const InformationTitle = ({
  to = '',
  title = '',
  subTitle = '',
  isCustomButtonLink = false,
  ...rest
}) => {
  const Title = ({ dangerouslySetInnerHTML, ...rest }) => (isCustomButtonLink ? (
    <StyledInformationTitle {...rest}>
      <StyledInformationTitleLink
        to={to}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...rest}
      />
    </StyledInformationTitle>
  ) : (
    <StyledInformationTitle
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      {...rest}
    />
  ));

  return !subTitle ? (
    <Title
      isSubTitleExists={!!subTitle}
      dangerouslySetInnerHTML={{ __html: title }}
      {...rest}
    />
  ) : (
    <StyledInformationTitle isSubTitleExists={!!subTitle} {...rest}>
      <b>{title}</b>
      <span>{subTitle}</span>
    </StyledInformationTitle>
  );
};

InformationTitle.defaultProps = {
  isCustomButtonLink: false,
  to: '',
};

InformationTitle.propTypes = {
  isCustomButtonLink: PropTypes.bool,
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
};

export default InformationTitle;
